module.exports = __webpack_public_path__ + "img/bathroom.be5030ca.webp";